import * as marietta from '../..';
import { SVGSprite } from '../flash/display';
import { Master } from '../model';
import { MonicaObject } from '.';
import { ITEM_MODE_NO } from '../Constants';

export default class Stair extends MonicaObject {
    wallView: Element;

    wallObjList: marietta.webcad.item.parts.Wall[];

    dummyWallView: Element;

    partner: marietta.webcad.item.parts.UpStair;

    public patternSpt: SVGSprite;

    // eslint-disable-next-line no-useless-constructor
    // constructor(_itemInfo: marietta.webcad.collection.ItemInfoCollection) {
    //   super(_itemInfo);
    // }

    /**
     * リドロー
     */
    reCreateImage() {
      // 部屋名の削除
      this.partner.deleteMe();

      this.patternSpt.element.remove();
      this.wallView.remove();
      this.dummyWallView.remove();

      // 反転を元に戻す
      const reverseLater: boolean = this.itemInfo.lr;
      if (reverseLater) this.reverse();

      // 再作成
      this.createImage();
      if (reverseLater) this.reverse();
    }

    /**
     * ビューの作成
     */
    createImage() {
      if (!this.spt) {
        const group: any = document.createElementNS('http://www.w3.org/2000/svg', 'g');
        this.spt = new SVGSprite(group);
        this.spt.rotation = 0;
      }

      // ドットリストの初期化
      if (this.itemInfo.dotList.length < 1) {
        const sizeInfo = marietta.webcad.WebCADGlobal.getStairSize(this.itemInfo.id);
        this.itemInfo.width = sizeInfo.width;
        this.itemInfo.height = sizeInfo.height;
        this.itemInfo.dotList = marietta.webcad.WebCADGlobal.getStairDotList(this.itemInfo.id);
      }

      const pattern: SVGElement = Master.getItemSvg(this.itemInfo.id);
      this.patternSpt = new SVGSprite(pattern);
      this.patternSpt.width = this.itemInfo.width;
      this.patternSpt.height = this.itemInfo.height;
      this.patternSpt.update();
      this.spt.addChild(this.patternSpt);

      // 壁
      this.wallObjList = [];
      this.wallView = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      this.wallView.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.index}wallGroup`);
      let wall: marietta.webcad.item.parts.Wall;
      for (let i: number = 0; i < this.itemInfo.dotList.length; i += 1) {
        // 生成
        wall = new marietta.webcad.item.parts.Wall(i, this.wallView, this.itemInfo.dotList[i], (i === this.itemInfo.dotList.length - 1) ? this.itemInfo.dotList[0] : this.itemInfo.dotList[i + 1]);
        wall.viewObj.setAttribute('stroke-linecap', 'square');
        wall.wallType = this.itemInfo.dotList[i].wall_type;
        wall.parentObj = this;
        this.wallObjList.push(wall);
      }
      this.viewObj.appendChild(this.wallView);

      // 穴を埋めるダミー壁
      if (this.dummyWallView) this.dummyWallView.remove();
      this.dummyWallView = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      this.dummyWallView.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.index}wallGroupDummy`);
      let dummyWallObj;
      let maeDot: marietta.webcad.collection.PointCollection;
      let atoDot: marietta.webcad.collection.PointCollection;
      let nextPoint: marietta.core.Point;
      let dot1: marietta.core.Point;
      let dot2: marietta.core.Point;
      let scale: number;
      let points = [];
      let wallColor;

      for (let i = 0; i < this.itemInfo.dotList.length; i += 1) {
        points = [];
        // 前後の壁
        maeDot = (i === 0) ? this.itemInfo.dotList[this.itemInfo.dotList.length - 1] : this.itemInfo.dotList[i - 1];
        atoDot = (i === this.itemInfo.dotList.length - 1) ? this.itemInfo.dotList[0] : this.itemInfo.dotList[i + 1];
        wallColor = marietta.webcad.WebCADGlobal.getColorForWallType(this.itemInfo.dotList[0].wall_type);

        // どちらかも壁じゃないときは次
        if (this.itemInfo.dotList[i].wall_type >= 1) {
          // 前の壁
          dot1 = new marietta.core.Point(maeDot.x, maeDot.y);
          dot2 = new marietta.core.Point(this.itemInfo.dotList[i].x, this.itemInfo.dotList[i].y);
          scale = ((marietta.core.Point.distance(dot1, dot2) - 5) / marietta.core.Point.distance(dot1, dot2));

          if (Math.abs(scale) === Infinity) {
            nextPoint = marietta.core.Point.interpolate(dot1, dot2, 1);
          } else {
            nextPoint = marietta.core.Point.interpolate(dot1, dot2, scale);
          }

          points.push(new marietta.core.Point(nextPoint.x, nextPoint.y));
          points.push(new marietta.core.Point(this.itemInfo.dotList[i].x, this.itemInfo.dotList[i].y));

          dot1 = new marietta.core.Point(this.itemInfo.dotList[i].x, this.itemInfo.dotList[i].y);
          dot2 = new marietta.core.Point(atoDot.x, atoDot.y);
          scale = (5 / marietta.core.Point.distance(dot1, dot2));
          if (Math.abs(scale) === Infinity) {
            nextPoint = dot2;
          } else {
            nextPoint = marietta.core.Point.interpolate(dot1, dot2, scale);
          }

          points.push(new marietta.core.Point(nextPoint.x, nextPoint.y));

          dummyWallObj = document.createElementNS('http://www.w3.org/2000/svg', 'path');
          dummyWallObj.setAttribute('d', marietta.webcad.util.SVGUtil.getPathString(points));
          dummyWallObj.setAttribute('stroke', wallColor.color);
          dummyWallObj.setAttribute('opacity', wallColor.alpha);
          dummyWallObj.setAttribute('stroke-width', marietta.webcad.WebCADGlobal.WALL_WIDTH);
          dummyWallObj.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.index}wallGroupDummy_${i}`);
          this.dummyWallView.appendChild(dummyWallObj);
        }
      }
      this.viewObj.appendChild(this.dummyWallView);

      this.spt.x = this.itemInfo.x;
      this.spt.y = this.itemInfo.y;
      this.spt.update();

      // 上階階段
      this.partner = new marietta.webcad.item.parts.UpStair(this);
    }

    /**
     * グリッドに吸い付く
     * */
    snapToGrid = () => {
      // k.kubonaka WEBCAD-916対応
      // 階段は中心原点になるため、左上起点でグリッドに沿う処理に修正
      const snapUnit = marietta.webcad.WebCADGlobal.webcad2Dmanager.snapUnitPix;
      let w2: number;
      let h2: number;

      // k.kubonaka  WEBCAD-1091対応
      if (this.itemInfo.rotation === 90 || this.itemInfo.rotation === 270) {
        w2 = this.itemInfo.height / 2;
        h2 = this.itemInfo.width / 2;
      } else {
        w2 = this.itemInfo.width / 2;
        h2 = this.itemInfo.height / 2;
      }

      let tmpX: number = this.itemInfo.x - w2;
      let tmpY: number = this.itemInfo.y - h2;

      tmpX = Math.round(tmpX / snapUnit) * snapUnit;
      tmpY = Math.round(tmpY / snapUnit) * snapUnit;

      // Debugger.text(0, "2 : " + w2 + "/" + h2 + ", ");
      this.itemInfo.x = tmpX + w2;// Math.round(this.itemInfo.x / snapUnit) * snapUnit;
      this.itemInfo.y = tmpY + h2;// Math.round(this.itemInfo.y / snapUnit) * snapUnit;

      // Debugger.text(1, this.itemInfo.x + " " + this.itemInfo.y);
      this.updateTransforms();

      // すでにカレントなので更新する必要性がない？
      // TODO: 確認
      // カレントの更新
      // marietta.webcad.WebCADGlobal.itemManager.currentItem = this;
    }

    /**
     * Translateのアップデート
     */
    updateTransforms() {
      this.spt.x = this.itemInfo.x;
      this.spt.y = this.itemInfo.y;

      this.spt.rotation = this.itemInfo.rotation;
      this.spt.update();

      // 上階階段もSNYC
      this.partner.syncToPartner();
    }

    /**
     * 子供を表示
     */
    showChildren=(): void => {
      const childrenList = [this.partner];
      for (let i: number = 0; i < childrenList.length; i += 1) {
        childrenList[i].show();
      }
    }

    /**
    * 子供を隠す
    */
    hideChildren=(): void => {
      const childrenList = [this.partner];
      for (let i: number = 0; i < childrenList.length; i += 1) {
        childrenList[i].hide();
      }
    }

    /**
     * 子供を移動
     */
    moveChildren=(): void => {
      const childrenList = [this.partner];
      for (let i: number = 0; i < childrenList.length; i += 1) {
        childrenList[i].syncToPartner();
      }
    }

    /**
     * 削除
     * */
    removeChildren=() => {
      const childrenList = [this.partner];
      for (let i: number = childrenList.length - 1; i >= 0; i -= 1) {
        childrenList[i].deleteMe();
      }
    }

    /**
     * 削除
     * */
    deleteMe(deferredObj = null) {
      super.deleteMe(deferredObj);
      marietta.webcad.WebCADGlobal.itemManager.getItemListByMode(ITEM_MODE_NO.MODE_STAIR_NO);
    }

    /**
     * サイズ変更
     * @param Number 幅
     * @param Number 高
     * @param Boolean ピクセル単位か否か
     * */
    changeSize(w: number, h: number, isPixUnit: Boolean = true) {
      let _w: number = w;
      let _h: number = h;

      // サイズ変更
      if (!isPixUnit) {
        this.itemInfo.widthmm = Math.round(_w);
        this.itemInfo.heightmm = Math.round(_h);
        // ピクセル単位
        _w = Math.round(marietta.webcad.util.WebCADUtil.convertMMToPix(_w));
        _h = Math.round(marietta.webcad.util.WebCADUtil.convertMMToPix(_h));
      } else {
        this.itemInfo.widthmm = Math.round(marietta.webcad.util.WebCADUtil.convertPixToMM(_w));
        this.itemInfo.heightmm = Math.round(marietta.webcad.util.WebCADUtil.convertPixToMM(_h));
      }

      this.itemInfo.width = Math.round(Math.abs(_w));
      this.itemInfo.height = Math.round(_h);

      const sizeInfo = marietta.webcad.WebCADGlobal.getStairSize(this.itemInfo.id);
      const scaleX: number = this.itemInfo.width / sizeInfo.width;
      const scaleY: number = this.itemInfo.height / sizeInfo.height;

      // ドットの初期化
      const motoList = this.itemInfo.dotList.concat();
      this.itemInfo.dotList = marietta.webcad.WebCADGlobal.getStairDotList(this.itemInfo.id);

      for (let i: number = 0; i < this.itemInfo.dotList.length; i += 1) {
        this.itemInfo.dotList[i].x *= scaleX;
        this.itemInfo.dotList[i].y *= scaleY;
        this.itemInfo.dotList[i].wall_type = motoList[i].wall_type;
        this.itemInfo.dotList[i].guid = motoList[i].guid;
      }
      this.reCreateImage();
      // パネル更新
      marietta.webcad.WebCADGlobal.itemControlPanel.panelUpdate();
    }

    /**
     * 頂点XMLの取得
     */
    getPointXML(): Element[] {
      const pointNodeList = [];
      let pointNode;
      // let globalPoint: marietta.core.Point;
      // let localPoint: marietta.core.Point;

      for (let i = 0, len = this.itemInfo.dotList.length; i < len; i += 1) {
        pointNode = document.createElementNS(null, 'point');
        pointNode.setAttribute('index', String(i + 1));
        pointNode.setAttribute('x', this.itemInfo.dotList[i].x);
        pointNode.setAttribute('y', -this.itemInfo.dotList[i].y);
        pointNode.setAttribute('wall_type', this.itemInfo.dotList[i].wall_type);
        pointNodeList.push(pointNode);
      }
      return pointNodeList;
    }

    /**
     * ロック可視化状態の変更
     */
    changeLockView(value: boolean) {
      super.changeLockView(value);
      if (value) {
        this.partner.hide();
      } else {
        this.partner.show();
      }
    }

    /**
     * 左右反転
     */
    reverse() {
      super.reverse();
      console.log('★★★★★★★');
      const result = this.spt.element.querySelectorAll('g');

      // 文字を反転させる
      for (let i: number = 0; i < result.length; i += 1) {
        if ((result[i] as Element).getAttribute('name') === 'moji') {
          (result[i] as Element).setAttribute('transform', marietta.webcad.WebCADGlobal.getTransformMatrixForReverseStairs(this));
        }
      }
      console.log(result);
    }
}
